import mapfn from "./map-fn-types";
import mapmod from "./map-module-types";

export default {
    mapfn,
    mapmod
}